export const initGalleries = (): void => {
  document.querySelectorAll<HTMLElement>('[data-gallery]').forEach((gallery) => {
    const overlay = gallery.querySelector<HTMLElement>('[data-gallery-overlay]');
    const stage = gallery.querySelector<HTMLElement>('[data-gallery-stage]');
    const stageCaption = gallery.querySelector<HTMLElement>('[data-gallery-caption]');
    const closeButton = gallery.querySelector<HTMLButtonElement>('[data-gallery-close]');
    const previousButton = gallery.querySelector<HTMLButtonElement>('[data-gallery-previous]');
    const nextButton = gallery.querySelector<HTMLButtonElement>('[data-gallery-next]');
    const triggers = Array.from(gallery.querySelectorAll<HTMLButtonElement>('[data-gallery-open]'));

    if (!overlay || !stage || !stageCaption || !closeButton || !previousButton || !nextButton || triggers.length === 0) {
      return;
    }

    let currentIndex = 0;
    let previouslyFocused: HTMLElement | null = null;

    const displayImage = (index: number): void => {
      const trigger = triggers[index];
      const caption = trigger?.querySelector<HTMLElement>('.gallery__caption');
      const imageSrc = trigger?.dataset.galleryStageSrc;

      if (!trigger || !imageSrc) {
        return;
      }

      const media = document.createElement('span');
      const image = document.createElement('img');
      media.className = 'gallery__media';
      image.src = imageSrc;
      image.alt = trigger.dataset.galleryStageAlt ?? '';
      media.append(image);

      currentIndex = index;
      stage.replaceChildren(media);
      stageCaption.textContent = caption?.textContent?.trim() ?? '';
    };

    const open = (index: number): void => {
      previouslyFocused = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      displayImage(index);
      overlay.hidden = false;
      document.documentElement.classList.add('has-overlay');
      closeButton.focus();
    };

    const close = (): void => {
      overlay.hidden = true;
      document.documentElement.classList.remove('has-overlay');
      previouslyFocused?.focus();
    };

    const showOffset = (offset: number): void => {
      const nextIndex = (currentIndex + offset + triggers.length) % triggers.length;
      displayImage(nextIndex);
    };

    triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => open(index));
    });

    closeButton.addEventListener('click', close);
    previousButton.addEventListener('click', () => showOffset(-1));
    nextButton.addEventListener('click', () => showOffset(1));
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) {
        close();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (overlay.hidden) {
        return;
      }

      if (event.key === 'Escape') {
        close();
      } else if (event.key === 'ArrowLeft') {
        showOffset(-1);
      } else if (event.key === 'ArrowRight') {
        showOffset(1);
      }
    });
  });
};
